import { motion } from "framer-motion";
import { ArrowUpRight, MapPin, Mail, Phone, Instagram } from "lucide-react";
import { login } from "../../context/AuthContext";

const SOCIALS = [
  { handle: "campierre_", url: "https://www.instagram.com/campierre_" },
  { handle: "iamjgolley", url: "https://www.instagram.com/iamjgolley" },
  { handle: "matchgrademediastl", url: "https://www.instagram.com/matchgrademediastl" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-brand-surface/30" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="flex flex-col md:flex-row md:items-end justify-between gap-10"
        >
          <h2 className="font-heading font-black uppercase text-5xl md:text-8xl tracking-tighter text-brand-ink leading-[0.85] max-w-3xl">
            Ready to<br />get to work?
          </h2>
          <button
            onClick={login}
            data-testid="footer-book-btn"
            className="group flex items-center gap-3 bg-brand-orange text-brand-bg font-mono text-xs uppercase tracking-[0.2em] px-8 py-5 hover:bg-brand-ink transition-colors whitespace-nowrap"
          >
            Create your portal
            <ArrowUpRight size={16} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
          </button>
        </motion.div>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-white/10 pt-12">
          <div className="flex items-start gap-3 text-brand-muted text-sm">
            <MapPin size={16} className="text-brand-orange mt-0.5" />
            <span>Serving the Midwest<br />St. Louis · Missouri</span>
          </div>
          <a href="mailto:train@midwestmade.com" className="flex items-start gap-3 text-brand-muted text-sm hover:text-brand-ink transition-colors">
            <Mail size={16} className="text-brand-orange mt-0.5" />
            train@midwestmade.com
          </a>
          <a href="tel:+13145550142" className="flex items-start gap-3 text-brand-muted text-sm hover:text-brand-ink transition-colors">
            <Phone size={16} className="text-brand-orange mt-0.5" />
            (314) 555-0142
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-3" data-testid="footer-socials">
          {SOCIALS.map((s) => (
            <a
              key={s.handle}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-ig-${s.handle}`}
              className="group flex items-center gap-2 border border-white/10 rounded-sm px-4 py-2.5 text-brand-muted hover:border-brand-orange hover:text-brand-ink transition-colors"
            >
              <Instagram size={14} className="text-brand-orange" />
              <span className="font-mono text-xs">@{s.handle}</span>
            </a>
          ))}
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <span className="flex items-center gap-3">
            <img src="/logo-mark.png" alt="Midwest Made" className="h-8 w-8" />
            <span className="font-heading font-black uppercase text-lg tracking-tight text-brand-ink">
              Midwest<span className="text-brand-orange">Made</span>
            </span>
          </span>
          <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-brand-muted">
            © {new Date().getFullYear()} Midwest Made Firearms Training · St. Louis, MO · Photography by Match Grade Media
          </span>
        </div>
      </div>
    </footer>
  );
}
